// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"Home_overlayWrapper__Pdml6","viewBox":"Home_viewBox__1imtj"};